import React, { Component } from "react";
import { connect } from "react-redux";
import Proptypes from "prop-types";

class ViewOciDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentDnsProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentDnsProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>User OCID</h4></td><td>{currentDnsProviderConfig.oci_user_ocid}</td></tr>
                <tr><td><h4>Private Key</h4></td><td>{currentDnsProviderConfig.oci_private_key}</td></tr>
                <tr><td><h4>Fingerprint</h4></td><td>{currentDnsProviderConfig.oci_fingerprint}</td></tr>
                <tr><td><h4>Tenancy OCID</h4></td><td>{currentDnsProviderConfig.oci_tenancy_ocid}</td></tr>
                <tr><td><h4>Region</h4></td><td>{currentDnsProviderConfig.oci_region}</td></tr>
                <tr><td><h4>Compartment OCID</h4></td><td>{currentDnsProviderConfig.oci_compartment_ocid}</td></tr>
            </React.Fragment>
        );
    }
}

ViewOciDnsProviderConfig.propTypes = {
    currentDnsProviderConfig: Proptypes.object.isRequired,
};

export default connect(state =>
({
}),
    dispatch =>
    ({
    }))(ViewOciDnsProviderConfig);
